<template>
  <el-table
    class="member-area-table"
    style="width: 100%"
    border
    :data="tableList"
    :maxHeight="maxHeight"
    :span-method="objectSpanMethod"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      prop="memberGradeName"
      label="会员等级"
      min-width="140"
      align="center"
    >
      <template slot-scope="{ row }">
        <textOverflowTooltip :content="row.memberGradeName" :lines="1" />
      </template>
    </el-table-column>
    <el-table-column
      prop="area"
      label="地域"
      min-width="120"
      align="center"
    >
      <template slot-scope="{ row }">
        <textOverflowTooltip :content="row.area" :lines="1" />
      </template>
    </el-table-column>
    <el-table-column
      prop="province"
      label="省"
      min-width="120"
      align="center"
      v-if="reportParams.areaDimension != 0"
    >
      <template slot-scope="{ row }">
        <textOverflowTooltip :content="row.province" :lines="1" />
      </template>
    </el-table-column>
    <el-table-column
      prop="city"
      label="市"
      min-width="120"
      align="center"
      v-if="reportParams.areaDimension == 2"
    >
      <template slot-scope="{ row }">
        <textOverflowTooltip :content="row.city" :lines="1" />
      </template>
    </el-table-column>
    <!-- <el-table-column
      prop="memberCount"
      label="会员数"
      min-width="120"
      align="center"
    />
    <el-table-column
      prop="memberRatio"
      label="会员数占比"
      min-width="140"
      align="center"
    /> -->
    <el-table-column
      prop="tradeCount"
      label="会员成交人数"
      min-width="120"
      align="center"
    />
    <el-table-column
      prop="tradeCountRatio"
      label="会员成交人数占比"
      min-width="140"
      align="center"
    />
    <el-table-column
      prop="tradeTimes"
      label="会员成交单量"
      min-width="120"
      align="center"
    />
    <el-table-column
      prop="tradeTimesRatio"
      label="会员成交单量占比"
      min-width="140"
      align="center"
    />
    <el-table-column
      prop="tradeAmount"
      label="会员成交金额"
      min-width="120"
      align="center"
    />
    <el-table-column
      prop="tradeAmountRatio"
      label="会员成交金额占比"
      min-width="140"
      align="center"
    />
    <el-table-column
      prop="tradeAvgAmount"
      label="客单价"
      min-width="120"
      align="center"
    />
  </el-table>
</template>

<script>
import mixins from "../../mixins/index.js";
import Empty from "../../components/empty.vue";

export default {
  name: "memberGradeAreaAnalysisTable",
  mixins: [mixins],
  components: {
    Empty,
    textOverflowTooltip: () => import("../../components/textOverflowTooltip.vue"),
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    reportParams: {
      type: Object,
      default: () => ({}),
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
  },
  computed: {
    tableList() {
      const ignoreKeys = ["memberGradeName", "area", "province", "city"];
      const list = (this.tableData || []).map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
          if (ignoreKeys.includes(key)) {
            newRow[key] = row[key];
            return;
          }
          if (key.endsWith("Ratio")) {
            newRow[key] = this.formatPercent(row[key]);
          } else if (
            key.endsWith("Count") || 
            key.endsWith("Amount") ||
            key.endsWith("Times")
          ) {
            newRow[key] = this.formatNumber(row[key]);
          } else {
            newRow[key] = row[key];
          }
        });
        return newRow;
      });
      return list;
    },
    prevReportView() {
      return this.reportParams.reportView || 0;
    },
    mergeColumnMap() {
      return this.prevReportView == 1
              ? {
                "memberGradeName": [ "memberGradeName" ],
                "area": [ "memberGradeName", "area" ],
                "province": [ "memberGradeName", "area", "province" ], // 级联合并
              }
              : {
                "memberGradeName": [ "memberGradeName" ],
              };
    },
    spanData() {
      const mergeMap = {};
      Object.keys(this.mergeColumnMap).forEach((prop) => {
        const posArr = [];
        let pos = 0;
        this.tableList.forEach((item, index) => {
          if (index === 0) {
            posArr.push(1);
            pos = 0;
          } else {
            let isSame = this.mergeColumnMap[prop].every((checkProp) => item[checkProp] === this.tableList[index - 1][checkProp]);
            if (isSame) {
              posArr[pos] += 1;
              posArr.push(0);
            } else {
              posArr.push(1);
              pos = index;
            }
          }
        });
        mergeMap[prop] = posArr;
      });
      return mergeMap;
    },
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.mergeColumnMap[column.property]) {
        const rowspan = this.spanData[column.property][rowIndex] || 0;
        return {
          rowspan: rowspan,
          colspan: rowspan > 0 ? 1 : 0,
        };
      }
      return {
        rowspan: 1,
        colspan: 1,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
// /deep/ .member-area-table .el-table__empty-block {
//   width: auto !important;
// }
</style>
